// src/utils/cars.js

// Named exports for both maps so they’re defined and importable elsewhere.
export const ACC_CAR_MODEL_MAP = {
  0: "Porsche 991 GT3 R",
  1: "Mercedes-AMG GT3",
  2: "Ferrari 488 GT3",
  3: "Audi R8 LMS",
  4: "Lamborghini Huracan GT3",
  5: "McLaren 650S GT3",
  6: "Nissan GT-R Nismo GT3 2018",
  7: "BMW M6 GT3",
  8: "Bentley Continental GT3 2018",
  9: "Porsche 991II GT3 Cup",
  10: "Nissan GT-R Nismo GT3 2017",
  11: "Bentley Continental GT3 2016",
  12: "Aston Martin V12 Vantage GT3",
  13: "Lamborghini Gallardo R-EX",
  14: "Jaguar G3",
  15: "Lexus RC F GT3",
  16: "Lamborghini Huracan Evo (2019)",
  17: "Honda NSX GT3",
  18: "Lamborghini Huracan SuperTrofeo",
  19: "Audi R8 LMS Evo (2019)",
  20: "AMR V8 Vantage (2019)",
  21: "Honda NSX Evo (2019)",
  22: "McLaren 720S GT3 (2019)",
  23: "Porsche 911II GT3 R (2019)",
  24: "Ferrari 488 GT3 Evo 2020",
  25: "Mercedes-AMG GT3 2020",
  26: "Ferrari 488 Challenge Evo",
  27: "BMW M2 CS Racing",
  28: "Porsche 911 GT3 Cup (Type 992)",
  29: "Lamborghini Huracán Super Trofeo EVO2",
  30: "BMW M4 GT3",
  31: "Audi R8 LMS GT3 evo II",
  32: "Ferrari 296 GT3",
  33: "Lamborghini Huracan Evo2",
  34: "Porsche 992 GT3 R",
  35: "McLaren 720S GT3 Evo 2023",
  36: "Ford Mustang GT3",
  50: "Alpine A110 GT4",
  51: "AMR V8 Vantage GT4",
  52: "Audi R8 LMS GT4",
  53: "BMW M4 GT4",
  55: "Chevrolet Camaro GT4",
  56: "Ginetta G55 GT4",
  57: "KTM X-Bow GT4",
  58: "Maserati MC GT4",
  59: "McLaren 570S GT4",
  60: "Mercedes-AMG GT4",
  61: "Porsche 718 Cayman GT4",
  80: "Audi R8 LMS GT2",
  82: "KTM XBOW GT2",
  83: "Maserati MC20 GT2",
  84: "Mercedes AMG GT2",
  85: "Porsche 911 GT2 RS CS Evo",
  86: "Porsche 935",
};

export const AC_CAR_MODEL_MAP = {
  "abarth500": "Abarth 500 EsseEsse",
  "abarth500_s1": "Abarth 500 EsseEsse S1",
  "alfa_romeo_giulietta_qv": "Alfa Romeo Giulietta QV",
  "alfa_romeo_giulietta_qv_le": "Alfa Romeo Giulietta QV Launch Edition",
  "bmw_1m": "BMW 1M Coupe",
  "bmw_1m_s3": "BMW 1M Stage 3",
  "bmw_m3_e30": "BMW M3 E30",
  "bmw_m3_e30_drift": "BMW M3 E30 Drift",
  "bmw_m3_e30_dtm": "BMW M3 E30 DTM",
  "bmw_m3_e30_gra": "BMW M3 E30 Gr.A",
  "bmw_m3_e30_s1": "BMW M3 E30 S1",
  "bmw_m3_e92": "BMW M3 E92",
  "bmw_m3_e92_drift": "BMW M3 E92 Drift",
  "bmw_m3_e92_s1": "BMW M3 E92 S1",
  "bmw_m3_gt2": "BMW M3 GT2",
  "bmw_z4": "BMW Z4 35is",
  "bmw_z4_drift": "BMW Z4 Drift",
  "bmw_z4_s1": "BMW Z4 Stage 1",
  "bmw_z4_gt3": "BMW Z4 GT3",
  "ferrari_458_italia": "Ferrari 458 Italia",
  "ferrari_458_italia_s3": "Ferrari 458 Italia S3",
  "ferrari_458_gt2": "Ferrari 458 GT2",
  "ferrari_f40": "Ferrari F40",
  "ferrari_f40_s3": "Ferrari F40 S3",
  "ferrari_laferrari": "Ferrari LaFerrari",
  "ktm_xbow_r": "KTM X-Bow R",
  "lotus_2_eleven": "Lotus 2-Eleven",
  "lotus_elise_sc": "Lotus Elise SC",
  "lotus_elise_sc_s1": "Lotus Elise SC Stage 1",
  "lotus_elise_sc_s2": "Lotus Elise SC Stage 2",
  "lotus_evora_gte": "Lotus Evora GTE",
  "lotus_evora_gte_carbon": "Lotus Evora GTE Carbon",
  "lotus_evora_gx": "Lotus Evora GX",
  "lotus_evora_s": "Lotus Evora S",
  "lotus_evora_s_s2": "Lotus Evora S Stage 2",
  "lotus_exige_240r": "Lotus Exige 240R",
  "lotus_exige_s": "Lotus Exige S",
  "lotus_exige_s_roadster": "Lotus Exige S Roadster",
  "lotus_exige_scura": "Lotus Exige Scura",
  "lotus_exige_v6_cup": "Lotus Exige V6 Cup",
  "lotus_exos_t125": "Lotus Exos T125",
  "lotus_exos_t125_s1": "Lotus Exos T125 Stage 1",
  "nissan_gtr_gt3": "Nissan GT-R Nismo GT3",
  "p4_5_competizione": "Scuderia Cameron Glickenhaus P4/5 Competizione",
  "pagani_huayra": "Pagani Huayra",
  "pagani_zonda_r": "Pagani Zonda R",
  "ruf_ctr_yellowbird": "RUF CTR Yellowbird",
  "ruf_rt12r": "RUF RT12R",
  "tatuusfa1": "Tatuus FA01",
  "toyota_gt86": "Toyota GT86",
  "toyota_supra_mkiv": "Toyota Supra MKIV",
  "toyota_supra_mkiv_drift": "Toyota Supra MKIV Drift",
  "toyota_supra_timeattack": "Toyota Supra Time Attack",
  "mazda_787b": "Mazda 787B",
  "audi_r8_lms": "Audi R8 LMS Ultra",
  "audi_r8_v10_plus": "Audi R8 V10 Plus",
  "mercedes_sls_amg_gt3": "Mercedes SLS AMG GT3",
  "mclaren_mp412c_gt3": "McLaren MP4-12C GT3",
  "mclaren_650s_gt3": "McLaren 650S GT3",
  "ferrari_488_gt3": "Ferrari 488 GT3",
  "lamborghini_huracan_gt3": "Lamborghini Huracán GT3",
  "lamborghini_huracan_st": "Lamborghini Huracán Super Trofeo",
  "mercedes_amg_gt3": "Mercedes AMG GT3",
  "praga_r1": "Praga R1",
  "maserati_mc12_gt1": "Maserati MC12 GT1",
  "maserati_gt_mc_gt4": "Maserati GranTurismo MC GT4",
  "mazda_rx7_spirit_r": "Mazda RX-7 Spirit R",
  "mazda_mx5_cup": "Mazda MX-5 Cup",
  "mazda_mx5_nd": "Mazda MX-5 ND",
  "audi_tt_cup": "Audi TT Cup",
  "audi_tt_vln": "Audi TT RS VLN",
  "audi_r18_etron": "Audi R18 e-tron quattro",
  "toyota_ts040": "Toyota TS040 Hybrid",
  "lotus_3_eleven": "Lotus 3-Eleven",
  "ferrari_250_gto": "Ferrari 250 GTO",
  "ferrari_330_p4": "Ferrari 330 P4",
  "ferrari_812_superfast": "Ferrari 812 Superfast",
  "ferrari_fxx_k": "Ferrari FXX K",
  "ferrari_sf15t": "Ferrari SF15-T",
  "ferrari_sf70h": "Ferrari SF70H",
  "ferrari_f2004": "Ferrari F2004",
  "porsche_911_gt3_r_2016": "Porsche 911 GT3 R (2016)",
  "porsche_911_gt3_rsr_2017": "Porsche 911 RSR (2017)",
  "porsche_911_gt3_cup_2017": "Porsche 911 GT3 Cup (2017)",
  "porsche_919_hybrid_2016": "Porsche 919 Hybrid (2016)",
  "porsche_962c": "Porsche 962C Short Tail",
  "porsche_917_k": "Porsche 917 K",
  "porsche_935_78": "Porsche 935/78 Moby Dick",
  "porsche_718_cayman_s": "Porsche 718 Cayman S",
  "porsche_718_boxster_s": "Porsche 718 Boxster S",
  "porsche_918_spyder": "Porsche 918 Spyder",
};

// Optional default export if you’re importing the bundle elsewhere.
export default { AC_CAR_MODEL_MAP, ACC_CAR_MODEL_MAP };
